// Page Transitions - Fade out/in on navigation
class PageTransitions {
  constructor() {
    this.duration = 400; // Duration in milliseconds
    this.isTransitioning = false;
    this.init();
  }

  init() {
    // Fade in on page load
    this.fadeIn();

    // Intercept link clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      
      // Skip if:
      // - Not a link
      // - External link
      // - Has target="_blank"
      // - Has download attribute
      // - Is a hash link on same page
      // - Already transitioning
      if (
        !link ||
        this.isTransitioning ||
        link.hostname !== window.location.hostname ||
        link.target === '_blank' ||
        link.hasAttribute('download') ||
        (link.pathname === window.location.pathname && link.hash)
      ) {
        return;
      }

      // Don't intercept cart drawer, popover, or dialog links
      if (
        link.hasAttribute('popovertarget') ||
        link.closest('dialog') ||
        link.closest('[role="dialog"]') ||
        link.getAttribute('on:click')?.includes('dialog')
      ) {
        return;
      }

      e.preventDefault();
      const href = link.href;
      this.navigateTo(href);
    });

    // Handle browser back/forward (bfcache restore)
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        this.fadeIn();
      }
    });
  }

  navigateTo(url) {
    this.isTransitioning = true;
    
    // Fade out
    this.fadeOut(() => {
      // Navigate after fade out
      window.location.href = url;
    });
  }

  fadeOut(callback) {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      if (callback) callback();
      return;
    }
    
    mainContent.style.transition = `opacity ${this.duration}ms ease`;
    mainContent.style.opacity = '0';

    setTimeout(() => {
      if (callback) callback();
    }, this.duration);
  }

  fadeIn() {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      this.isTransitioning = false;
      return;
    }
    
    // Start at 0 opacity
    mainContent.style.opacity = '0';
    
    // Force reflow
    mainContent.offsetHeight;
    
    // Fade in
    mainContent.style.transition = `opacity ${this.duration}ms ease`;
    mainContent.style.opacity = '1';

    // Scroll to top
    window.scrollTo(0, 0);

    // Reset transitioning state
    setTimeout(() => {
      this.isTransitioning = false;
      mainContent.style.transition = '';
    }, this.duration);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PageTransitions();
  });
} else {
  new PageTransitions();
}

